var PopupData = React.createContext({});
export var PopupDataProvider = PopupData.Provider;
export var PopupDataConsumer = PopupData.Consumer;
export default PopupData;